import { AfterViewInit, Component, ElementRef, Input, NgZone, OnInit, ViewChild } from '@angular/core';
import {
  BalanceQuery,
  BarcodeQuery,
  BarcodeService,
  config,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  ScreenType,
  SeatingDetail,
} from '@fgb/core';
import { map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit, AfterViewInit {
  @ViewChild('nav', { static: false }) navRef!: ElementRef<HTMLDivElement>;
  atRightEnd = false;
  displayPartner: boolean = false;

  @Input() isHomePage = false;
  @Input() isWallet = false;
  @Input() showWallet = true;
  @Input() showFooter = true;
  @Input() showBarcode: boolean = false;

  screenType = ScreenType;
  isTrialMember: boolean;
  barcode$: Observable<any>;
  card$: Observable<MemberCard | undefined>;
  member$: Observable<MemberDetails | undefined>;
  seatingDetail$: Observable<SeatingDetail | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  ecash$: Observable<number | undefined>;
  pointsBalance$: Observable<number | undefined>;
  combinedCard$: Observable<number | undefined>;

  loading$: Observable<boolean>;

  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);

    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
    this.loading$ = this.barcode$.pipe(
      map((barcode) => !barcode),
      startWith(true)
    );

    this.pointsBalance$ = this.balanceQuery
      .selectPurse(config.purseConfig.virtualLoyalty)
      .pipe(map((bal) => Math.ceil(bal ?? 0)));
  }

  //hide after for mobile nav
  ngAfterViewInit() {
    this.updateRightEnd();

    this.ngZone.runOutsideAngular(() => {
      const handler = () => this.ngZone.run(() => this.updateRightEnd());
      window.addEventListener('resize', handler);
    });
  }

  onNavScroll() {
    this.updateRightEnd();
  }

  private updateRightEnd() {
    const el = this.navRef?.nativeElement;
    if (!el) return;

    const { scrollLeft, clientWidth, scrollWidth, dir } = el;

    const isRtl = (dir || getComputedStyle(el).direction) === 'rtl';
    const current = isRtl ? Math.abs(scrollLeft) : scrollLeft;

    const epsilon = 1;
    this.atRightEnd = current + clientWidth >= scrollWidth - epsilon;
  }
}
